import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

const Affiliate = () => {
	const navigate = useNavigate()

	useEffect(() => {
		window.open(
			"https://platform.shoffi.app/signup/affiliate?app=Il_gR6v4PDV",
			"_blank",
		)
		navigate(-1)
	}, [])

	return ""
}

export default Affiliate
